const DebtSecuritySubType = Object.freeze({
  ASSET_BACKED_SECURITY: "ASSET_BACKED_SECURITY",
  BOND: "BOND",
  DEBENTURE: "DEBENTURE",
  HYBRID_SECURITY: "HYBRID_SECURITY",
  OTHER_DEBT_SECURITY: "OTHER_DEBT_SECURITY",
});

export default DebtSecuritySubType;
